import FieldUtils from "../../../utils/FieldUtils";

// Handles auto file mapping for MultiSubitems
export function handleComplexAutoMap(
  newMappedHeaders,
  fieldAPIName,
  complexHeaders,
  lowercaseHeaders,
  headers,
  subitemName // For when the Complex Field is inside of a Subitem
) {
  const indexPosition = fieldAPIName.length + 1;
  const indexes = {};

  complexHeaders.forEach((h) => {
    if (!indexes[h[indexPosition]]) {
      indexes[h[indexPosition]] = [h];
    } else {
      indexes[h[indexPosition]].push(h);
    }
  });

  newMappedHeaders[fieldAPIName] = {
    Type: "Identifier",
    Fields: Object.keys(indexes).map((i) => {
      const Fields = {};

      for (let header of indexes[i]) {
        if (subitemName) {
          header = subitemName.toLowerCase() + "." + header.toLowerCase();
        }

        const foundIndex = lowercaseHeaders.indexOf(header);

        if (foundIndex < 0) continue;

        let foundHeader = headers[foundIndex];
        let nestedAPIName;

        if (subitemName) {
          // 4 because there is a 4 extra separating characters throughout the SubitemComplexField
          nestedAPIName = foundHeader.substring(
            fieldAPIName.length + subitemName.length + 4
          );
        } else {
          nestedAPIName = foundHeader.substring(indexPosition + 2);
        }

        Fields[nestedAPIName] = { Identifier: foundHeader };
      }

      return { Fields };
    }),
  };
}

function mapSubitemHeaders(
  headersToLoop,
  lowercaseHeaders,
  headers,
  Fields,
  fieldMap
) {
  const multiDotHeaders = [];
  const nestedComplexHeaders = {};
  const partiallyComplexHeaders = {};
  let fieldAPIName = "";

  for (const header of headersToLoop) {
    const foundIndex = lowercaseHeaders.indexOf(header);

    if (foundIndex < 0) continue;

    let foundHeader = headers[foundIndex];
    let splitFoundHeader = foundHeader.split(".");

    if (!fieldAPIName && splitFoundHeader[0]) {
      fieldAPIName = splitFoundHeader[0];
    }

    if (splitFoundHeader?.length > 2) {
      const complex = splitFoundHeader[1].split("_");

      // Manage Subitem's Complex Field auto mapping
      if (complex.length > 1) {
        const complexAPIName = complex[0];
        const complexString = splitFoundHeader[1] + "." + splitFoundHeader[2];

        if (nestedComplexHeaders[complexAPIName]) {
          nestedComplexHeaders[complexAPIName].push(complexString);
        } else {
          nestedComplexHeaders[complexAPIName] = [complexString];
        }

        continue;
      }

      const splitFieldAPIName = fieldAPIName.split("_");
      const newFieldAPIName =
        splitFieldAPIName.length > 1
          ? splitFieldAPIName?.includes("RemoteSystems")
            ? "_RemoteSystems"
            : splitFieldAPIName[0]
          : fieldAPIName;

      const foundField = fieldMap[newFieldAPIName + "." + splitFoundHeader[1]];

      if (FieldUtils.isPartiallyComplex(foundField?.FieldType)) {
        foundHeader = splitFoundHeader[1] + "." + splitFoundHeader[2];

        if (partiallyComplexHeaders[splitFoundHeader[1]]) {
          partiallyComplexHeaders[splitFoundHeader[1]].push(foundHeader);
        } else {
          partiallyComplexHeaders[splitFoundHeader[1]] = [foundHeader];
        }

        continue;
      }

      foundHeader = splitFoundHeader[0] + "." + splitFoundHeader[1];

      if (
        ["CreatedBy", "LastUpdatedBy"].includes(splitFoundHeader[1]) ||
        foundField?.FieldType === "SingleReference"
      ) {
        foundHeader = foundHeader + ".id";
      }

      if (multiDotHeaders.includes(foundHeader)) continue;

      multiDotHeaders.push(foundHeader);
    }

    let nestedAPIName = splitFoundHeader[1];

    Fields[nestedAPIName] = { Identifier: foundHeader };
  }

  for (const key of Object.keys(nestedComplexHeaders)) {
    handleComplexAutoMap(
      Fields,
      key,
      nestedComplexHeaders[key],
      lowercaseHeaders,
      headers,
      fieldAPIName
    );
  }

  // Handle partially complex fields inside a Subitem
  for (const key of Object.keys(partiallyComplexHeaders)) {
    if (!Fields[key])
      Fields[key] = { Fields: [{ Fields: {} }], Type: "Identifier" };

    const fields = Fields[key].Fields[0].Fields;

    for (const key2 of partiallyComplexHeaders[key]) {
      const splitKey2 = key2.split(".");
      fields[splitKey2[1]] = { Identifier: `${fieldAPIName}.${key2}` };
    }
  }
}

// Handles auto file mapping for Single Subitems
export function handleSubitemAutoMap(
  newMappedHeaders,
  fieldAPIName,
  subitemHeaders,
  lowercaseHeaders,
  headers,
  fieldMap
) {
  const Fields = [{ Fields: {} }];

  mapSubitemHeaders(
    subitemHeaders,
    lowercaseHeaders,
    headers,
    Fields[0].Fields,
    fieldMap
  );

  newMappedHeaders[fieldAPIName] = {
    Type: "Identifier",
    Fields: Fields,
  };
}

export function handleMultiSubitemAutoMap(
  newMappedHeaders,
  fieldAPIName,
  subitemHeaders,
  lowercaseHeaders,
  headers,
  fieldMap
) {
  const indexPosition = fieldAPIName.length + 1;
  const indexes = {};

  subitemHeaders.forEach((h) => {
    if (!indexes[h[indexPosition]]) {
      indexes[h[indexPosition]] = [h];
    } else {
      indexes[h[indexPosition]].push(h);
    }
  });

  newMappedHeaders[fieldAPIName] = {
    Type: "Identifier",
    Fields: Object.keys(indexes).map((i) => {
      const Fields = {};

      mapSubitemHeaders(
        indexes[i],
        lowercaseHeaders,
        headers,
        Fields,
        fieldMap
      );

      return { Fields };
    }),
  };
}
